<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="Judgment Day" src="images/9780802197382_0002.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Halftitle_1.vue?47b29ae8